<a target="_blank" [href]="(doc.document && doc.document?.url.startsWith('https')) ? doc.document?.url : 'https://'+doc.document?.url" *ngFor="let doc of documents">
	<span>
		<i class="far fa-file-alt"></i>
	</span>
	{{ doc.title }}
</a>
